import client from '@/services/';

const state = () => ({
    all: [],
    one: {},
    fichier: [],
    /** Liste paginée des participants (connecté) — ne pas confondre avec all = formations */
    participantsPage: {},
});

const getters = {
    all: state => state.all,
    one: state => state.one,
    fichier: state => state.fichier,
    participantsPage: state => state.participantsPage,
};

const mutations = {
    SET_ALL: (state, obj) => {
        state.all = obj;
    },
    SET_PARTICIPANTS_PAGE: (state, obj) => {
        state.participantsPage = obj;
    },
    SET_ONE: (state, obj) => {
        state.one = obj;
    },
    SET_FICHIER: (state, obj) => {
        state.fichier = obj;
    },
};

const actions = {
    async getAllP(cxt) {
        let data = await client.get('/formation');
        cxt.commit("SET_ALL", data);
        return data;
    },
    async getAllPage({ commit }, params = {}) {
        const { page = 0, size = 10, sort = '', title, publie} = params;
        const queryParams = new URLSearchParams({
            page,
            size,
            sort,
            ...(title && { title }),
            ...(publie && { publie }),
        }).toString();
        let { data } = await client.get(`/formation?${queryParams}`);
        commit("SET_ALL", data)
        return data;
    },
    async getOne(cxt, code) {
        let data = await client.get('/formation/verification/' + code);
        cxt.commit("SET_ONE", data);
        return data;
    },
    async create(cxt, payload) {
        let { data } = payload.id ? await client.put('/formation/' + payload.id, payload) : await client.post('/formation/add', payload);
        cxt.commit("SET_ONE", data);
        if (payload.id) {
            payload.id = null;
        }

        return data;
    },
    async del(cxt, id) {
        let { data } = await client.delete('/formation/' + id);
        cxt.commit("SET_ONE", data);
        return data;
    },
    async uploadImage({ commit }, { payload }) {
        try {
            const data = await client.post('fichier/add/simple', payload, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            commit('SET_FICHIER', data);
            return data;

        } catch (error) {
            console.error('Erreur lors de l\'ajout du document :', error);
            throw error;
        }
    },
    async participer(cxt, payload) {
        let { data } = await client.post('/participants/add', payload);
        return data;
    },
    async preparer(cxt, payload) {
        let { data } = await client.post('/participants/preparer', payload);
        return data;
    },
    async confirmerPaiement(cxt, { participantId, transactionId }) {
        let { data } = await client.post('/participants/confirmer', { participantId, transactionId });
        return data;
    },
    async getOneParticipant(cxt, id) {
        let data = await client.get('/participants/' + id);
        return data;
    },
    async getOneParticipant({ commit }, params = {}) {
        const { page = 0, size = 10, sort = '', formationTitle, aSuivi, after, before} = params;
        const queryParams = new URLSearchParams({
            page,
            size,
            sort,
            ...(formationTitle && { formationTitle }),
            ...(aSuivi && { aSuivi }),
            ...(after && { after }),
            ...(before && { before })
        }).toString();
        let { data } = await client.get(`/participants/connected?${queryParams}`);
        commit("SET_PARTICIPANTS_PAGE", data);
        return data;
    },
    async participantSignature(cxt, payload) {
        let { data } = await client.post('/participants/sign', payload);
        return data;
    },
    async participationIndividuel({ commit }, { formationCode, participantIds }) {
        let { data } = await client.post(`/participants/sent/attestation/formation/${formationCode}`, participantIds);
        return data;
    },
    async participationGrouper({ commit }, formationCode) {
        let { data } = await client.get(`/participants/sent/attestation/${formationCode}`);
        return data;
    },
    async sendMailAgain({ commit }, code) {
        let { data } = await client.get(`/formation/resend/mail/${code}`);
        return data;
    },
    async sendMeetingLink({ commit }, code) {
        let { data } = await client.get(`/formation/resend/meeting-link/${code}`);
        return data;
    },
    async sendMeetingLinkToParticipants({ commit }, { formationCode, participantIds }) {
        try {
            const response = await client.get(`/formation/resend/meeting-link/${formationCode}/participant/${participantIds}`, { participantIds });
            return response.data;
        } catch (error) {
            console.error('Erreur lors de l\'envoi des liens de réunion:', error);
            throw error;
        }
    },
    async sendFileFormation({ commit }, { payload }) {
        // Nouvelle API: POST /participants/sent/support avec participantIds, fichiersIds, driveLink
        let { data } = await client.post(`/participants/sent/support`, payload);
        return data;
    },
    async addFilesToFormation({ commit }, { formationId, fichiersIds }) {
        // Ajoute plusieurs fichiers à une formation
        const { data } = await client.post(`/formation/${formationId}/files`, fichiersIds);
        return data;
    },
    async getParticipantFormation(cxt, { id, params }) {
        const queryParams = new URLSearchParams();
        
        if (params.page !== undefined) queryParams.append('page', params.page);
        if (params.size !== undefined) queryParams.append('size', params.size);
        if (params.sort && params.sort.length > 0) {
            params.sort.forEach(sortItem => queryParams.append('sort', sortItem));
        }
        if (params.search) queryParams.append('search', params.search);
        if (params.presence) queryParams.append('presence', params.presence);
        
        const url = `/participants/formation/${id}?${queryParams.toString()}`;
        let data = await client.get(url);
        return data;
    },
    async rappelFormation({ commit }, formationCode) {
        let { data } = await client.get(`/participants/sent/rappel/${formationCode}`);
        return data;
    },
    async statitistiqueType({ commit }, formationId) {
        let { data } = await client.get(`/participants/stats/formation-type/${formationId}`);
        return data;
    },
    async getParticipantAyantSigner(cxt, id) {
        let data = await client.get('/formation/signature/' + id);
        return data;
    },
    async exportExcel({ commit }, formationId) {
        try {
                        
            const response = await client.get(`/participants/formation/${formationId}/export/excel`, {
                responseType: 'blob'
            });
            return response.data;
        } catch (error) {
            console.error('Erreur lors de l\'export Excel:', error);
            throw error;
        }
    },
    async exportAllFormationToExcel({ commit }) {
        try {
                        
            const response = await client.get(`/formation/export/excel`, {
                responseType: 'blob'
            });
            return response.data;
        } catch (error) {
            console.error('Erreur lors de l\'export Excel:', error);
            throw error;
        }
    },
    async validatePaiementParticipant({ commit }, { id, dateValidationPaiement }) {
        const payload = { dateValidationPaiement };
        let { data } = await client.put(`/participants/${id}/validation-paiement`, payload);
        return data;
    },
    async checkInscription(cxt, { email, formationId }) {
        try {
            const queryParams = new URLSearchParams({
                email: email,
                formationId: formationId
            }).toString();
            let { data } = await client.get(`/participants/check-inscription?${queryParams}`);
            return data;
        } catch (error) {
            console.error('Erreur lors de la vérification d\'inscription:', error);
            throw error;
        }
    },
    // Actions pour les questionnaires
    async createQuestionnaire({ commit }, payload) {
        let { data } = await client.post('/questionnaire/add', payload);
        return data;
    },
    async getQuestionnaireById({ commit }, id) {
        let { data } = await client.get(`/questionnaire/${id}`);
        return data;
    },
    async getQuestionnairesByFormation({ commit }, formationId) {
        let { data } = await client.get(`/questionnaire/formation/${formationId}`);
        return data;
    },
    async updateQuestionnaire({ commit }, { id, payload }) {
        let { data } = await client.put(`/questionnaire/${id}`, payload);
        return data;
    },
    async deleteQuestionnaire({ commit }, id) {
        let { data } = await client.delete(`/questionnaire/${id}`);
        return data;
    },
    async getQuestionnaireByLien({ commit }, lienUnique) {
        let { data } = await client.get(`/questionnaire/lien/${lienUnique}`);
        return data;
    },
    // Actions pour les réponses aux questionnaires
    async submitReponseQuestionnaire({ commit }, payload) {
        let { data } = await client.post('/reponse-questionnaire/submit', payload);
        return data;
    },
    async updateReponseQuestionnaire({ commit }, payload) {
        let { data } = await client.put('/reponse-questionnaire/submit', payload);
        return data;
    },
    async getReponseQuestionnaireById({ commit }, id) {
        let { data } = await client.get(`/reponse-questionnaire/${id}`);
        return data;
    },
    async getReponsesByQuestionnaire({ commit }, questionnaireId) {
        let { data } = await client.get(`/reponse-questionnaire/questionnaire/${questionnaireId}`);
        return data;
    },
    async getQuestionnaireStatistics({ commit }, questionnaireId) {
        let { data } = await client.get(`/reponse-questionnaire/questionnaire/${questionnaireId}/statistics`);
        return data;
    },
    async getReponsesByFormation({ commit }, formationId) {
        let { data } = await client.get(`/reponse-questionnaire/formation/${formationId}`);
        return data;
    },
    async getReponseByParticipantAndQuestionnaire({ commit }, { questionnaireId, participantId }) {
        let { data } = await client.get(`/reponse-questionnaire/questionnaire/${questionnaireId}/participant/${participantId}`);
        return data;
    },
    async sendQuestionnaireLink({ commit }, { formationCode, participantIds }) {
        try {
            const response = await client.post(`/formation/send-questionnaire-link/${formationCode}`, { participantIds });
            return response.data;
        } catch (error) {
            console.error('Erreur lors de l\'envoi du lien de questionnaire:', error);
            throw error;
        }
    },
    async sendQuestionnaireMailToFormation({ commit }, formationId) {
        try {
            const response = await client.get(`/questionnaire/send-mail/formation/${formationId}`);
            return response.data;
        } catch (error) {
            console.error('Erreur lors de l\'envoi du lien de questionnaire à la formation:', error);
            throw error;
        }
    },
    async sendQuestionnaireMailToParticipant({ commit }, { formationId, participantId }) {
        try {
            const response = await client.get(`/questionnaire/send-mail/formation/${formationId}/participant/${participantId}`);
            return response.data;
        } catch (error) {
            console.error('Erreur lors de l\'envoi du lien de questionnaire au participant:', error);
            throw error;
        }
    },
    async utiliserQuestionnaireBase({ commit }, formationId) {
        try {
            const response = await client.post(`/questionnaire/formation/${formationId}/utiliser-questionnaire-base`);
            return response.data;
        } catch (error) {
            console.error('Erreur lors de la création du questionnaire de base:', error);
            throw error;
        }
    },
    // Actions pour la révocation et le rechargement de documents
    async revoquerDocument({ commit }, { participantId, raisonRejet }) {
        try {
            const payload = raisonRejet ? { raisonRejet } : {};
            const { data } = await client.post(`/participants/${participantId}/revoquer-document`, payload);
            return data;
        } catch (error) {
            console.error('Erreur lors de la révocation du document:', error);
            throw error;
        }
    },
    async getInfoRechargement({ commit }, token) {
        try {
            const { data } = await client.get(`/participants/recharger/${token}`);
            return data;
        } catch (error) {
            console.error('Erreur lors de la récupération des informations de rechargement:', error);
            throw error;
        }
    },
    async rechargerDocument({ commit }, { token, fichierId }) {
        try {
            const { data } = await client.post(`/participants/recharger/${token}`, { fichierId });
            return data;
        } catch (error) {
            console.error('Erreur lors du rechargement du document:', error);
            throw error;
        }
    },
    async getStatsAttestation({ commit }, formationCode) {
        let { data } = await client.get(`/participants/stats/attestation/${formationCode}`);
        return data;
    },
    async getFormationsExternes({ commit }, params = {}) {
        const { page = 0, size = 100, sort = 'dateDebutFormation,desc', formationTitle, statut, after, before } = params;
        const queryParams = new URLSearchParams({
            page,
            size,
            sort,
            ...(formationTitle && { formationTitle }),
            ...(statut && { statut }),
            ...(after && { after }),
            ...(before && { before }),
        }).toString();
        let { data } = await client.get(`/formation-externe/connected?${queryParams}`);
        return data;
    },
    async createFormationExterne(cxt, payload) {
        let { data } = await client.post('/formation-externe/add', payload);
        return data;
    },
    async updateFormationExterne(cxt, { id, payload }) {
        let { data } = await client.put(`/formation-externe/${id}`, payload);
        return data;
    },
    async deleteFormationExterne(cxt, id) {
        let { data } = await client.delete(`/formation-externe/${id}`);
        return data;
    },
    async getFormationsExternesAdmin({ commit }, params = {}) {
        const { page = 0, size = 10, sort = 'createdAt,desc', formationTitle, statut } = params;
        const queryParams = new URLSearchParams({
            page,
            size,
            sort,
            ...(formationTitle && { formationTitle }),
            ...(statut && { statut }),
        }).toString();
        let { data } = await client.get(`/formation-externe/admin/all?${queryParams}`);
        return data;
    },
    async getFormationsExternesAdminStats() {
        let { data } = await client.get('/formation-externe/admin/stats');
        return data;
    },
    async getFormationExterneAdmin(id) {
        let { data } = await client.get(`/formation-externe/admin/${id}`);
        return data;
    },
    async validerFormationExterne(cxt, id) {
        let { data } = await client.put(`/formation-externe/admin/${id}/valider`);
        return data;
    },
    async rejeterFormationExterne(cxt, { id, motifRejet }) {
        let { data } = await client.put(`/formation-externe/admin/${id}/rejeter`, { motifRejet });
        return data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
